import { SERVICE_TYPE } from '@/api/type/commonTypes';
import {
  GetAllServiceResponse,
  GetPartnerServiceOptionsResponse,
} from '@/api/type/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ServiceActiveType {
  serviceType: SERVICE_TYPE;
  active: boolean;
}
interface ServiceState {
  partnerServiceOptions: GetPartnerServiceOptionsResponse[]; // 파트너가 선택한 서비스 옵션 조회
  allService: GetAllServiceResponse[]; // 서비스 전체 옵션 조회
  putPartnerServiceOptions: Partial<
    // 서비스타입별로 옵션 데이터 저장
    Record<SERVICE_TYPE, GetPartnerServiceOptionsResponse | null>
  >;
}

const initialState: ServiceState = {
  partnerServiceOptions: [],
  allService: [],
  putPartnerServiceOptions: {},
};

export const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    setPartnerServiceOptions: (
      state,
      action: PayloadAction<GetPartnerServiceOptionsResponse[]>
    ) => {
      state.partnerServiceOptions = action.payload;
    },
    setAllService: (state, action: PayloadAction<GetAllServiceResponse[]>) => {
      state.allService = action.payload;
    },
    setServiceActive: (
      state,
      action: PayloadAction<{ serviceType: SERVICE_TYPE; active: boolean }>
    ) => {
      const { serviceType, active } = action.payload;

      const target = state.partnerServiceOptions.find(
        (item) => item.serviceType === serviceType
      );

      if (!target) return;

      target.active = active;
    },
    setPutPartnerServiceOptions: (
      state,
      action: PayloadAction<{
        serviceType: SERVICE_TYPE;
        data: GetPartnerServiceOptionsResponse | null;
      }>
    ) => {
      const { serviceType, data } = action.payload;
      state.putPartnerServiceOptions[serviceType] = data;
    },
  },
});

export const service = serviceSlice.actions;
export default serviceSlice.reducer;
